import { env } from "@/src/env.mjs";

type EntellicaIconProps = {
  size?: 14 | 16 | 28 | 32 | 42;
};

export const EntellicaIcon = ({ size = 32 }: EntellicaIconProps) => (
  // eslint-disable-next-line @next/next/no-img-element
  <img
    src={`${env.NEXT_PUBLIC_BASE_PATH ?? ""}/icon.svg`}
    width={size}
    height={size}
    alt="Entellica Icon"
  />
);
